import { Directive, HostListener } from '@angular/core';

const ALLOWED_CONTROL_KEYS = new Set([
  'Backspace', 'Tab', 'Delete', 'Enter', 'Escape',
  'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
  'Home', 'End',
]);

@Directive({
  selector: '[appDateOnly]',
  standalone: true,
})
export class DateOnlyDirective {
  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (event.ctrlKey || event.metaKey) return;
    if (ALLOWED_CONTROL_KEYS.has(event.key)) return;
    // Aceita dígitos e a barra do separador
    if (!/^[\d/]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  /**
   * Auto-formata o campo como dd/mm/yyyy enquanto o usuário digita.
   * O p-calendar do PrimeNG só consegue parsear se o valor já estiver no formato esperado,
   * então a gente insere as barras automaticamente após 2 e 4 dígitos.
   */
  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement | null;
    if (!input) return;

    const rawValue = input.value ?? '';
    const cursorBefore = input.selectionStart ?? rawValue.length;

    const digits = rawValue.replace(/\D/g, '').slice(0, 8);
    let formatted = digits;
    if (digits.length >= 5)      formatted = `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
    else if (digits.length >= 3) formatted = `${digits.slice(0, 2)}/${digits.slice(2)}`;

    if (rawValue === formatted) return;

    // Quantos dígitos havia antes do cursor original — preserva posição lógica
    const digitsBeforeCursor = rawValue.slice(0, cursorBefore).replace(/\D/g, '').length;
    let newCursor = digitsBeforeCursor;
    if (newCursor > 4)       newCursor += 2;
    else if (newCursor > 2)  newCursor += 1;
    newCursor = Math.min(newCursor, formatted.length);

    input.value = formatted;
    input.setSelectionRange(newCursor, newCursor);

    // Re-dispara para o ngModel/formControl pegar o novo valor.
    // Não causa loop pois a próxima execução vê rawValue === formatted e sai cedo.
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
